import { useMemo } from "react";
import { VChart } from "@visactor/react-vchart";

const SaleHistoryChart = ({ groups, months, values, metric }) => {
    const spec = useMemo(() => {
        const seriesData = [];
        months.forEach((month) => {
            groups.forEach((group) => {
                seriesData.push({
                    month,
                    group,
                    value: values[group]?.[month] || 0,
                });
            });
        });

        return {
            type: "line",
            data: {
                values: seriesData,
            },
            xField: "month",
            yField: "value",
            seriesField: "group",
            axes: [
                {
                    orient: "bottom",
                    title: { visible: false },
                    label: { style: { fontSize: 11 } },
                },
                {
                    orient: "left",
                    title: { visible: false },
                    label: {
                        style: { fontSize: 11 },
                        formatMethod: (val) => {
                            if (metric === "amount") {
                                if (val >= 1000000) return "$" + (val / 1000000).toFixed(1) + "M";
                                if (val >= 1000) return "$" + (val / 1000).toFixed(1) + "K";
                                return "$" + val.toFixed(0);
                            }
                            if (val >= 1000000) return (val / 1000000).toFixed(1) + "M";
                            if (val >= 1000) return (val / 1000).toFixed(1) + "K";
                            return val.toFixed(0);
                        },
                    },
                },
            ],
            legends: {
                visible: true,
                orient: "bottom",
                item: {
                    label: {
                        style: {
                            fontSize: 11,
                        },
                        formatMethod: (text) =>
                            text.length > 14 ? text.substring(0, 14) + "..." : text,
                    },
                },
            },
            point: {
                visible: true,
                style: {
                    size: 4,
                },
            },
            line: {
                style: {
                    curveType: "linear",
                    lineWidth: 2,
                },
            },
            tooltip: {
                dimension: {
                    content: [
                        {
                            key: (datum) => datum.group,
                            value: (datum) => {
                                const val = datum.value || 0;
                                return metric === "amount" ? "$" + val.toFixed(2) : val.toFixed(2);
                            },
                        },
                    ],
                },
            },
        };
    }, [groups, months, values, metric]);

    if (groups.length === 0 || months.length === 0) {
        return null;
    }

    return (
        <div style={{ width: "100%", height: 400, minWidth: 600 }}>
            <VChart spec={spec} />
        </div>
    );
};

export default SaleHistoryChart;
